<div class="panel panel-data">
    <div class="panel-header">
        <h3 class="panel-title">All Economic Data</h3>
    </div>
    <div class="panel-content">
        <div class="cat-list">
            <div class="cat-list-item" *ngFor="let section of sections">
                <div class="cat-list-item-header">
                    <a class="cat-list-item-title dropdown-toggle"
                       (click)="updateToggle(section)"
                       [ngClass]="{'is-opened': this.dropdownTogglesShow[section]}">{{ section }}</a>
                </div>
                <div class="cat-list-item-body"
                     *ngFor="let sectionItem of this.data[section] | keyvalue:originalOrder"
                     [ngClass]="{'show': this.dropdownTogglesShow[section]}">
                    <a class="cat-list-link"
                       [href]="sectionItem.value">
                        {{ sectionItem.key }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
